(function () {
  window.dataLayer = window.dataLayer || [];

  const config = window.uis24TrackingConfig || {};
  const currency = config.currency || 'EUR';

  function pushEvent(eventName, data) {
    const payload = Object.assign(
      {
        event: eventName,
        page_location: window.location.href,
        page_title: document.title,
      },
      data || {}
    );

    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      const gtagPayload = Object.assign({}, payload);
      delete gtagPayload.event;
      window.gtag('event', eventName, gtagPayload);
    }
  }

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function parseMoney(value) {
    if (!value) return undefined;
    const normalized = String(value).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  function productPayloadFromElement(element) {
    const productCard = element.closest('[data-uis24-product]');
    if (!productCard) return {};

    const price = parseMoney(productCard.dataset.price);
    const item = {
      item_id: productCard.dataset.variantId || productCard.dataset.productId,
      item_name: productCard.dataset.productTitle,
      item_category: productCard.dataset.productCategory,
      item_variant: productCard.dataset.variantTitle,
      price,
      quantity: 1,
      google_business_vertical: 'retail',
    };

    return {
      currency,
      value: price,
      items: [item],
    };
  }

  function queryFromForm(form) {
    const input = form.querySelector('input[type="search"], input[name="q"]');
    return cleanText(input ? input.value : '');
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const label = cleanText(link.textContent) || link.getAttribute('aria-label') || '';

    if (href.startsWith('tel:')) {
      pushEvent('phone_click', {
        event_category: 'contact',
        contact_method: 'phone',
        link_url: href,
        link_text: label,
      });
      return;
    }

    if (href.startsWith('mailto:')) {
      pushEvent('email_click', {
        event_category: 'contact',
        contact_method: 'email',
        link_url: href,
        link_text: label,
      });
      return;
    }

    if (href.includes('wa.me') || href.includes('whatsapp')) {
      pushEvent('whatsapp_click', {
        event_category: 'contact',
        contact_method: 'whatsapp',
        link_url: href,
        link_text: label,
      });
      return;
    }

    if (href.includes('google.com/maps/dir') || href.includes('maps.google') || label.toLowerCase().includes('route')) {
      pushEvent('route_click', {
        event_category: 'contact',
        contact_method: 'route',
        link_url: href,
        link_text: label,
      });
      return;
    }

    if (link.closest('[data-uis24-product]')) {
      pushEvent('select_item', productPayloadFromElement(link));
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('form[role="search"], form[action*="/search"]')) {
      const query = queryFromForm(form);
      if (query) {
        pushEvent('search', {
          event_category: 'engagement',
          search_term: query,
        });
      }
    }

    if (form.matches('.uis24-contact-location__form, form[action*="/contact"]')) {
      pushEvent('contact_form_submit', {
        event_category: 'contact',
        form_id: form.id || 'contact',
        form_name: 'Kontaktformular',
      });

      pushEvent('generate_lead', {
        event_category: 'contact',
        form_id: form.id || 'contact',
        form_name: 'Kontaktformular',
      });
    }

    if (form.matches('form.newsletter-form, .newsletter-form')) {
      const tagsInput = form.querySelector('input[name="contact[tags]"]');
      const tags = tagsInput ? tagsInput.value : '';
      if (tags.includes('newsletter')) {
        pushEvent('newsletter_signup', {
          event_category: 'email',
          form_id: form.id || 'newsletter',
          form_name: 'Newsletter',
        });
      }
    }

    if (form.id === 'cart' || form.action.includes('/cart')) {
      const submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') {
        pushEvent('begin_checkout', {
          event_category: 'ecommerce',
          currency,
        });
      }
    }
  });

  document.addEventListener('uis24:add_to_cart', (event) => {
    const detail = event.detail || {};
    const item = detail.item || {};
    const price =
      typeof item.final_price === 'number'
        ? item.final_price / 100
        : typeof detail.fallbackPrice === 'number'
          ? detail.fallbackPrice / 100
          : undefined;

    pushEvent('add_to_cart', {
      currency: detail.currency || currency,
      value: typeof price === 'number' ? price * (item.quantity || 1) : undefined,
      items: [
        {
          item_id: item.sku || item.variant_id || item.id,
          item_name: item.product_title || detail.fallbackTitle || item.title,
          item_category: item.product_type,
          item_variant: item.variant_title,
          price,
          quantity: item.quantity || 1,
          google_business_vertical: 'retail',
        },
      ],
    });
  });
})();
